import React, { useState, useEffect } from "react";
import axios from "../common/axios";
import Layout from "../layout/Layout";
import { Circles } from "react-loader-spinner";
import { MFormTable } from "../common/formtable/mdrawingtable";
import useDocumentTitle from "../common/useDocumentTitle";
import { useLocation } from "react-router-dom";
import { SearchableCombobox } from "../components/SearchableCombobox";

const DrawingM = () => {
  const [moduleData, setModuleData] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [timeData, setTimeData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [projectCodeList, setProjectCodeList] = useState([]);
  const [projectCode, setProjectCode] = useState({
    projectnumber: "",
    projectname: "",
  });
  const [areaList, setAreaList] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  useDocumentTitle("SHI DP 제작도 계획");
  const [userData, setUserData] = useState({});
  // 프로젝트 코드 상태 초기화
  useEffect(() => {
    const projectnumber = localStorage.getItem("projectnumber");
    const projectname = localStorage.getItem("projectname");
    if (projectname && projectnumber) {
      setProjectCode({
        projectnumber: projectnumber,
        projectname: projectname,
      });
    }
  }, []);

  // 프로젝트 코드 변경 시 로컬 스토리지에 저장
  useEffect(() => {
    if (projectCode && projectCode.projectname !== "") {
      localStorage.setItem("projectnumber", projectCode.projectnumber);
      localStorage.setItem("projectname", projectCode.projectname);
    }
  }, [projectCode]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userResponse = await axios.post(
          `/dpcurrent_user`,
          {},
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        setUserData(userResponse.data); // Set user data using Recoil
      } catch (userError) {
        console.error("Error fetching user data:", userError);
        // Handle error in fetching user data
      }
    };
    fetchData();
  }, [location]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(`/getprojectlist`);
      if (res.data.success) {
        const data = res.data.data;
        setProjectCodeList(data);
      }
    };
    fetchData();
  }, [location]);

  useEffect(() => {
    const fetchData = async () => {
      if (projectCode && projectCode.projectnumber) {
        setLoading(true);

        // Fetch project data
        const projectRes = await axios.get(
          `/getdpMdata?path=${projectCode.projectnumber}`
        );
        if (projectRes.data.success) {
          const discipline = userData.DPDisciplineMS;
          if (discipline !== undefined) {
            const data = projectRes.data.data.data
              .map((v) => ({
                ...v,
                WStart:
                  v.WStart !== null ? new Date(v.WStart.slice(0, 10)) : null,
              }))
              .filter((v) => discipline.includes(v.DrawingDiscPD));

            setTableData(data);
          }
        }

        // Fetch module data
        const moduleRes = await axios.get(
          `/getmodule?path=${projectCode.projectnumber}`
        );
        let newModuleData = [];
        if (moduleRes.data.success) {
          newModuleData = moduleRes.data.data.data.map((v, index) => ({
            ...v,
            id: index + 1,
            MDSitePlanDO: new Date(v.MDSitePlanDO.slice(0, 10)),
          }));
        }

        // Fetch time data
        const timeRes = await axios.get(
          `/getleadtime?path=${projectCode.projectnumber}`
        );
        let newTimeData = [];
        if (timeRes.data.success) {
          newTimeData = timeRes.data.data.data;
        }

        // Set all state variables at once

        setModuleData(newModuleData);
        setTimeData(newTimeData);

        setLoading(false);
      }
    };

    fetchData();
  }, [projectCode, userData]); // Dependency array

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(`/getvendors`);
      if (res.data.success) {
        const data = res.data.data.data;
        setVendorList(data.map((v) => v.uveVendorNameTB50));
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (projectCode && projectCode.projectnumber !== "") {
        const res = await axios.get(
          `/getdparea?path=${projectCode.projectnumber}`
        );
        if (res.data.success) {
          const data = res.data.data.data;

          setAreaList(data.map((v) => v.DPArea));
        }
      }
    };
    fetchData();
  }, [projectCode]);

  return (
    <>
      <Layout pageTitle="제작도 · 계획 작성">
        <div className="flex h-full min-h-0 flex-col">
          <div className="flex shrink-0 items-end justify-end gap-3 py-4 px-6">
            <SearchableCombobox
              label="Project"
              value={projectCode?.projectnumber || ""}
              onChange={(newValue) => {
                const found = projectCodeList.find((p) => p.projectnumber === newValue);
                setProjectCode(found || { projectnumber: "", projectname: "" });
              }}
              options={projectCodeList.map((p) => ({
                value: p.projectnumber,
                label: p.projectname || "",
              }))}
              placeholder="Project 선택"
              width={300}
            />
          </div>
          <div className="flex flex-1 min-h-0 flex-col px-6 pb-6">
            {loading &&
            projectCode !== null &&
            projectCode.projectnumber !== "" &&
            tableData.length > 0 ? (
              <div className="loadingContainer">
                <Circles
                  ariaLabel="loading"
                  color="#00BFFF"
                  height={100}
                  width={100}
                />
              </div>
            ) : (
              <MFormTable
                projectCode={projectCode}
                moduleData={moduleData}
                areaList={areaList}
                vendorList={vendorList}
                tabeldata={tableData}
                newkey={"record_no"}
                pddata={moduleData}
                timeData={timeData}
              />
            )}
          </div>
        </div>
      </Layout>
    </>
  );
};
export default DrawingM;
